import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiMail, FiCheckCircle } from "react-icons/fi";
import "./AdminContactMessages.css";

const API_BASE = "https://api.thetotetherapy.com";

export default function AdminContactMessages() {
  const navigate = useNavigate();
  const [msgs, setMsgs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMsgs = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_BASE}/api/contact`);
      const data = await res.json();
      setMsgs(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMsgs();
  }, []);

  const markRead = async (id) => {
    try {
      await fetch(`${API_BASE}/api/contact/${id}/read`, { method: "PATCH" });
      // update UI instantly
      setMsgs((prev) =>
        prev.map((m) => (m.id === id ? { ...m, is_read: 1 } : m))
      );
    } catch (e) {
      console.error(e);
    }
  };

  const unread = msgs.filter((m) => Number(m.is_read) === 0).length;

  return (
    <main className="admMsgsPage">
      <div className="admMsgsTop">
        <h2 className="admMsgsTitle">
          <FiMail /> Contact Messages
          <span className="admMsgsBadge">{unread} Unread</span>
        </h2>
        <button className="admBackBtn" onClick={() => navigate("/admin/dashboard")}>
          Back to Dashboard
        </button>
      </div>

      {loading ? (
        <div className="admMsgsState">Loading messages...</div>
      ) : msgs.length === 0 ? (
        <div className="admMsgsState">No messages yet.</div>
      ) : (
        <div className="admMsgsGrid">
          {msgs.map((m) => (
            <article className={`admMsgCard ${Number(m.is_read) ? "read" : "unread"}`} key={m.id}>
              <div className="admMsgHead">
                <div>
                  <h3 className="admMsgName">{m.name}</h3>
                  <p className="admMsgMeta">{m.email}</p>
                </div>

                <div className="admMsgRight">
                  {!Number(m.is_read) ? (
                    <span className="pillUnread">Unread</span>
                  ) : (
                    <span className="pillRead">Read</span>
                  )}
                </div>
              </div>

              <p className="admMsgText">{m.message}</p>

              <div className="admMsgActions">
                {!Number(m.is_read) && (
                  <button className="markReadBtn" onClick={() => markRead(m.id)}>
                    <FiCheckCircle /> Mark as read
                  </button>
                )}
              </div>
            </article>
          ))}
        </div>
      )}
    </main>
  );
}